import type { FeedbackMessages } from './en';

const ko: FeedbackMessages = {
  qualified: {
    title: '조사에 참여해 주셔서 감사합니다!',
    body1: '이제 브라우저 창을 닫으셔도 됩니다.',
    body2: '앞으로도 다시 뵙기를 기대하겠습니다.',
    refCode: '참조 코드: {code}',
  },
  quotaFull: {
    title: '해당 조사는 마감되었습니다',
    body1: '조사에 관심을 가져 주셔서 감사합니다.',
    body2: '아쉽게도 이미 필요한 응답 수를 모두 확보하였습니다.',
    body3: '앞으로 진행될 다른 조사에서 다시 만나 뵐 수 있기를 바랍니다!',
    refCode: '참조 코드: {code}',
  },
  terminated: {
    title: '소중한 의견을 주셔서 감사합니다!',
    body1: '앞으로 진행될 조사에서 다시 뵙기를 기대하겠습니다. 그때까지 좋은 하루 보내시기 바랍니다.',
    body2: '이 브라우저 창을 닫아 주십시오.',
    refCode: '참조 코드: {code}',
  },
  mismatch: {
    title: '관심을 가져 주셔서 감사합니다',
    body1: '아쉽게도 이번 조사의 대상 그룹에 해당하지 않습니다.',
    body2: '이 페이지를 닫으셔도 됩니다.',
    code: '코드: {code}',
  },
  error: {
    title: '요청을 처리할 수 없습니다',
    linkProblemDetailed:
      '접속하신 링크에 문제가 발생했습니다. 주소창의 링크가 전달받으신 링크와 일치하는지 확인하신 후 다시 시도해 주십시오.',
    linkProblemGeneric: '접속하신 링크에 문제가 발생했습니다. 다시 시도해 주십시오.',
    contactPerson:
      '문제가 계속될 경우, 링크를 전달해 주신 담당자에게 이 문제를 알려 주시기 바랍니다.',
    errorCode: '오류 코드: {code}',
  },
};

export default ko;
